export type Size = {
    height: number;
    width: number;
};

export type Page = {
    left: string;
    right: string;
};
